export const CLINIC_NO_ASSOC_ID = 0;
